import { NavLink, useLocation } from "react-router-dom";
import { useUiLabels } from "../labels/LabelsContext";
import { TbLayoutSidebarLeftCollapse, TbLayoutSidebarLeftExpand } from "react-icons/tb";
import Button from "../Button";
import MobileNav from "../MobileNav";
import "./styles/index.scss";

// App sidebar (desktop) and mobile drawer. The app decides which entries are visible.
// primary / secondary: [{ to, labelKey, icon, activePath = to, exact = false }]
// mobileNav: props for the drawer (logo, profileTo, onLogout).
const SideBarShell = ({
  primary = [],
  secondary = [],
  primaryLabelKey,
  secondaryLabelKey,
  isMobile,
  isIcon: isIconPref,
  onToggleIcons,
  impersonationActive,
  mobileNav,
}) => {
  // Su mobile le etichette devono sempre essere visibili
  const isIcon = Boolean(isIconPref) && !isMobile;
  const { pathname } = useLocation();
  const [getLabel] = useUiLabels();
  const toggleLabel = getLabel(isIcon ? "sidebarExpand" : "sidebarCollapse");

  const renderItem = ({ to, labelKey, icon, activePath = to, exact = false }) => (
    <NavLink key={labelKey} to={to}>
      <Button
        isRed
        isFull
        label={isIcon ? "" : getLabel(labelKey)}
        customClassName={`sidebar_container_action ${isIcon ? "icon" : ""}`}
        isNavLink
        isActive={exact ? pathname === activePath : pathname.startsWith(activePath)}
        customIcon={icon}
        disableIcon={false}
        isPlainIcon
      />
    </NavLink>
  );

  const primaryNav = <div className="sidebar_container_primary">{primary.map(renderItem)}</div>;
  const secondaryNav = <div className="sidebar_container_secondary">{secondary.map(renderItem)}</div>;

  if (isMobile) {
    return (
      <MobileNav {...mobileNav}>
        {primaryNav}
        {secondaryNav}
      </MobileNav>
    );
  }

  return (
    <aside className={`sidebar_container ${isIcon ? "icons" : ""} ${impersonationActive ? "impersonation_active" : ""}`}>
      {!isIcon && primary.length > 0 && primaryLabelKey && (
        <h2 className="sidebar_container_section_label">{getLabel(primaryLabelKey)}</h2>
      )}
      {primaryNav}
      {!isIcon && secondary.length > 0 && secondaryLabelKey && (
        <h2 className="sidebar_container_section_label">{getLabel(secondaryLabelKey)}</h2>
      )}
      {secondaryNav}

      <button
        type="button"
        className={`show_icons ${isIcon ? "open" : ""}`}
        onClick={onToggleIcons}
        aria-expanded={!isIcon}
        aria-label={toggleLabel}
        title={isIcon ? toggleLabel : undefined}
      >
        {isIcon ? (
          <TbLayoutSidebarLeftExpand className="show_icons_icon" size={22} aria-hidden="true" />
        ) : (
          <TbLayoutSidebarLeftCollapse className="show_icons_icon" size={22} aria-hidden="true" />
        )}
        {!isIcon && <span className="show_icons_label">{toggleLabel}</span>}
      </button>
    </aside>
  );
};

export default SideBarShell;
